"use server";

import { cookies } from "next/headers";
import { redirect } from "next/navigation";

import { ACCESS_COOKIE, ACCESS_VALUE, DEFAULT_ENTRY, safeInternalPath } from "@/lib/access";

/** Landmark 页密令，校验通过后才会放行到站内各详情页 */
const PASSPHRASE = "ts@2026!";

export type VerifyState = { error: string | null };

export async function verifyPassphrase(
  _prevState: VerifyState,
  formData: FormData,
): Promise<VerifyState> {
  const input = formData.get("passphrase");
  const next = formData.get("next");

  if (typeof input !== "string" || input !== PASSPHRASE) {
    return { error: "密令不正确，请重新输入。" };
  }

  // 会话级 Cookie：不设置 expires/maxAge，浏览器关闭即失效，因此每次来访都需重新输入密令
  const store = await cookies();
  store.set(ACCESS_COOKIE, ACCESS_VALUE, {
    httpOnly: true,
    sameSite: "lax",
    path: "/",
  });

  redirect(safeInternalPath(typeof next === "string" ? next : null) ?? DEFAULT_ENTRY);
}
